import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	"data-name": "Icon - Seach",
	viewBox: "-0.5 -0.5 25.5 25.5",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		"data-name": "Group 966",
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 8,
			"data-name": "Ellipse 155",
			transform: "translate(.75 .75)"
		}), /* @__PURE__ */ _jsx("path", {
			d: "m14.687 14.535 9.063 9.215",
			"data-name": "Line 346"
		})]
	})
});
export { SvgIconSearch as ReactComponent };
